import { ViewModel,View, ViewGenerator, ViewModelMessage } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { CompiledClass } from "src/formBuilder/datamodel/classGenerator";
import { DataModel } from "src/formBuilder/datamodel/structure";
import { ServerConnection } from "src/server/serverConnection";
import { ITemplateSelector } from "src/uicomponents/components/templateSelector";
import { MediaSelector } from "uicomponents";
import  { FormExecutorView } from "./formExecutor-view"


export class FormExecutionParameter{
    formId:string;
    formName:string;
}

export class FormExecutorViewModel extends WindowViewModel implements ITemplateSelector{
    public getTitle(): string {
        return this.formName;
    }
    constructor(parentViewModel: ViewModel,executionParameter?: FormExecutionParameter) {
        super(parentViewModel);
        if(executionParameter==null){
            executionParameter = new FormExecutionParameter();
            executionParameter.formId = '705e3bea-a9e2-486f-89e0-efca01a0de41';
            executionParameter.formName = "test";
        }
        this.formId = executionParameter.formId;
        this.formName =executionParameter.formName;
        this.templateSelector = this;
        this.templates = [];
        this.loadForm();
    }
    GetDefaultView(): View <ViewModel> {
        return new FormExecutorView();
    }
    public getTypeId(): string {
        return "VM-944D0986-9F07-4724-A37B-2DA704DD426D"
    }

    public set formId(v: string) { this._formId = v; } public get formId(): string { return this._formId;} private _formId: string;
    public set formName(v: string) { this._formName = v;this.title = v; } public get formName(): string { return this._formName;} private _formName: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    private templates : Template[];
    private dataModel : DataModel;
    
    public set viewModel(v: ViewModel) { this._viewModel = v; } public get viewModel(): ViewModel { return this._viewModel;} private _viewModel: ViewModel;
    public set mainTemplateSelector(v: string) { this._mainTemplateSelector = v; } public get mainTemplateSelector(): string { return this._mainTemplateSelector;} private _mainTemplateSelector: string;
    public set templateSelector(v: ITemplateSelector) { this._templateSelector = v; } public get templateSelector(): ITemplateSelector { return this._templateSelector;} private _templateSelector: ITemplateSelector;
    
    public set popupTemplateSelector(v: string) { this._popupTemplateSelector = v; } public get popupTemplateSelector(): string { return this._popupTemplateSelector;} private _popupTemplateSelector: string;
    public set popupWidth(v: string) { this._popupWidth = v; } public get popupWidth(): string { return this._popupWidth;} private _popupWidth: string;
    public set popupHeight(v: string) { this._popupHeight = v; } public get popupHeight(): string { return this._popupHeight;} private _popupHeight: string;
    

    public async loadForm(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/BpmsRawDataServices/GetFormInfo',{
                FormId : this.formId
            });
            let formInfo = JSON.parse(result.FormInfo);
            let dataModel = new DataModel(this);
            dataModel.Parse(formInfo.DataModel);
            dataModel.generateClasses(this);
            this.dataModel = dataModel;
            let templates = formInfo.FormData.Templates;
            templates.forEach(t => {
                let template = new Template();
                template.name = t.Name;
                template.className = t.ClassName;
                let dataModelClass = this.dataModel.classes.filter(x=>x.name==t.ClassName)[0];
                let compiledClass = this.dataModel.GetCompliledClass(dataModelClass); 
                template.dataModelClass = compiledClass;
                template.isMain = t.IsMain;
                template.mediaType = t.MediaType ?? 0;
                let html : string = t.Html;
                html = html.replaceAll('data-b-comp-itemtemplateselector="','data-b-comp-importanthasselectorfunction="{Binding importanthasselectorfunction}"data-b-comp-itemtemplateselector="');
                template.html = html;
                template.htmlProto = ViewGenerator.CreatePrototype(html,'3169b9c8-8886-4885-8962-b197e3c391b4');
                this.templates.push(template);
            });

            let mainTemplates = this.templates.filter(x=>x.isMain==true)
            let mainViewModel = this.filterTemplateByMediaType(mainTemplates);
            this.mainTemplateSelector = `return "${mainViewModel.name}"`;
            let newInstance = mainViewModel.dataModelClass.__CreateNewInstance__(this);
            newInstance._Builder_TemplateSelector__ = this;
            this.viewModel = newInstance;

        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    filterTemplateByMediaType(templates:Template[]):Template{
        try{
            let result = MediaSelector.GetObjectByMediaType({
                default : ()=> <any>templates.filter(x=>x.mediaType==0).at(0),
                landscapeDefault : ()=> <any>templates.filter(x=>x.mediaType==1).at(0),
                portraitDefault : ()=> <any>templates.filter(x=>x.mediaType==2).at(0),
                portraitPhone : ()=> <any>templates.filter(x=>x.mediaType==3).at(0),
                landscapePhone : ()=> <any>templates.filter(x=>x.mediaType==4).at(0),
                portraitTablet : ()=> <any>templates.filter(x=>x.mediaType==5).at(0),
                landscapeTablet : ()=> <any>templates.filter(x=>x.mediaType==6).at(0),
                portraitLargeTablet : ()=> <any>templates.filter(x=>x.mediaType==7).at(0),
                landscapeLargeTablet : ()=> <any>templates.filter(x=>x.mediaType==8).at(0),
                desktop : ()=> <any>templates.filter(x=>x.mediaType==9).at(0),
            },true);
            return <Template>result;
        }catch{
            return null;
        }
    }
    getTemplate(vm: ViewModel, selector: string) {
        let functionProto = Function(`a=function(vm){${selector}};return a;`);
        let executableFunction = functionProto();
        let name = executableFunction(vm);
        let foundTemplatesNoMedia = this.templates.filter(x=>x.name==name);
        let found = this.filterTemplateByMediaType(foundTemplatesNoMedia);
        if(found==null)
            return null;
        let foundTemplate = found;
        return foundTemplate.htmlProto;
    }
    handleMessage(msg:ViewModelMessage){
        if(msg instanceof NodeExecutorRequestShowingPopupMessage){
            return this.requestShowingPopup(msg.popup,false,{
                template : msg.template,
                width : msg.width,
                height : msg.height
            });
        }else{
            return super.handleMessage(msg);
        }
    }
    public popupChanging(popup:IPopup,autoHide:boolean,additionalInfo:any){
        this.popupWidth = additionalInfo?.width ?? "auto";
        this.popupHeight = additionalInfo?.height ?? "auto";
        this.popupTemplateSelector = additionalInfo?.template;
    }
}

class Template{
    public name:string;
    public className:string;
    public dataModelClass : CompiledClass;
    public isMain:boolean;
    public html:string;
    public htmlProto : any;
    public mediaType : number;
}

export class NodeExecutorRequestShowingPopupMessage extends ViewModelMessage{
    public popup: IPopup;
    public template : any;
    public width:string;
    public height:string;    
}